module.exports = __webpack_public_path__ + "./images/nodata.e6856b.jpg";